<template>
  <div ref="container" class="xl:col-span-8 text-center">
    <step-title :title="'Struktuur'"/>
    <div class="mt-6 md:mt-10 md:grid md:grid-cols-2 gap-8 max-w-sm md:max-w-xl mx-auto">
      <structure-one-pager @onClick="onFeatureClick" :is-selected="selected === 'onePage'" :feature-key="'onePage'"/>
      <structure-multi-page @onClick="onFeatureClick" :is-selected="selected === 'multiPage'" :feature-key="'multiPage'"/>
    </div>
  </div>
</template>

<script>
import calculatorSteps from "@/mixins/calculatorSteps";
import StepTitle from "@/components/calculator-steps/utils/StepTitle";
import StructureOnePager from "@/components/calculator-steps/calculator-page-structure/StructureOnePager";
import StructureMultiPage from "@/components/calculator-steps/calculator-page-structure/StructureMultiPage";

export default {
  name: "CalculatorPageStructure",
  components: {
    StepTitle,
    StructureOnePager,
    StructureMultiPage
  },
  mixins: [calculatorSteps],
  data: () => ({
    selected: 'onePage'
  }),
  methods: {
    onFeatureClick(featureKey) {
      this.selected = featureKey
      this.$store.dispatch('prices/STRUCTURE', featureKey)
    }
  }

}
</script>

<style>
</style>
